import React, { useState } from 'react'
import { DialogContent } from '@material-ui/core'
import Button from '@mostrans/web-components/components/base/Button'
import { Dialog, DialogActions, DialogTitle, Typography } from '@mui/material'
import PreviewIcon from '@mui/icons-material/Preview';
import "./assets/preassesment.css"
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

function ModalPdfPreassesment(props) {
    const [modalOpen, setModalOPen] = useState(false)
    const { dataCandidateByID } = props

    const handleOpenModal = () => {
        setModalOPen(true)
    }

    const handleModalClose = () => {
        setModalOPen(false)
    }

    const createProfilePdf = () => {
        const input = document.getElementById('divToPrint');
        html2canvas(input,)
            .then((canvas) => {
                let imgWidth = 210;
                let imgHeight = canvas.height * imgWidth / canvas.width;
                const imgData = canvas.toDataURL('img/png');
                const pdf = new jsPDF('p', 'mm', 'a4');
                pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
                pdf.save("pre-assesment.pdf");
            })
    }


    return (
        <React.Fragment>
            <Button
                color="primary"
                startIcon={<PreviewIcon />}
                onClick={handleOpenModal}
            >
                Preview To Export
            </Button>
            <Dialog open={modalOpen} onClose={handleModalClose} fullWidth="xl" maxWidth="xl">
                <DialogTitle>Preview To Export</DialogTitle>
                <DialogContent>
                    <div className="row">
                        <div className="col-md-12" style={{ display: "flex", justifyContent: "flex-end" }}>
                            <Button
                                color="primary"
                                startIcon={<FileDownloadOutlinedIcon />}
                                onClick={createProfilePdf}
                            >
                                Save to PDF
                            </Button>
                        </div>
                    </div>
                    <div className="book">
                        <div className="page" id='divToPrint'>
                            <div className="subpage">
                                <div className="row mt-2">
                                    <div className="col-md-12">
                                        <Typography style={{ fontSize: "15px" }}>
                                            {dataCandidateByID?.full_name} - PreAssesment | {dataCandidateByID?.PreAssessment?.created_date}
                                        </Typography>
                                    </div>
                                    <div className="col-md-12 mt-2">
                                        <Typography id="soal-1" align="justify">
                                            1. Ceritakanlah kejadian atau masalah yang pernah anda alami di
                                            dalam pekerjaan (boleh di tempat kerja saat ini atau di tempat
                                            kerja sebelumnya) yang dampak atau hasilnya Anda rasakan sebagai
                                            sukses besar atau kepuasan bagi diri Anda. (Apabila anda
                                            freshgraduate maka boleh memberikan pengalaman selama masa
                                            pendidikan).
                                        </Typography>
                                        <Typography sx={{ fontWeight: "500" }}>
                                            Answer: <br />
                                            {dataCandidateByID.PreAssessment?.answer1
                                                ? dataCandidateByID?.PreAssessment?.answer1
                                                : "-"}
                                        </Typography>
                                    </div>
                                    <div className="col-md-12 mt-2">
                                        <Typography id="soal-2" align="justify">
                                            2. Ceritakanlah kejadian atau masalah yang pernah Anda alami di
                                            dalam pekerjaan (boleh di tempat kerja saat ini atau di tempat
                                            kerja sebelumnya) yang dampak atau hasilnya Anda rasakan sebagai
                                            suatu kegagalan besar atau ketidakpuasan bagi Anda.
                                        </Typography>
                                        <Typography sx={{ fontWeight: "500" }}>
                                            Answer: <br />
                                            {dataCandidateByID.PreAssessment?.answer2
                                                ? dataCandidateByID?.PreAssessment?.answer2
                                                : "-"}
                                        </Typography>
                                    </div>
                                    <div className="col-md-12 mt-2">
                                        <Typography id="soal-3" align="justify">
                                            3. Ceritakan secara terperinci improvement/perbaikan yang telah
                                            Anda lakukan selama ini, baik di tempat kerja saat ini atau di
                                            tempat kerja sebelumnya.
                                        </Typography>
                                        <Typography sx={{ fontWeight: "500" }}>
                                            Answer: <br />
                                            {dataCandidateByID.PreAssessment?.answer3
                                                ? dataCandidateByID?.PreAssessment?.answer3
                                                : "-"}
                                        </Typography>
                                    </div>
                                    <div className="col-md-12 mt-2">
                                        <Typography id="soal-4" align="justify">
                                            4. Apakah Anda pernah / sedang diproses di Kalbe Group?
                                        </Typography>
                                        <Typography sx={{ fontWeight: "500" }}>
                                            Answer: <br />
                                            {dataCandidateByID.PreAssessment?.answer4 === true
                                                ? "YA"
                                                : "TIDAK"}
                                        </Typography>
                                    </div>
                                    {
                                        dataCandidateByID?.PreAssessment?.answer4 === true ? (
                                            <div className="col-md-12 mt-2">
                                                <Typography id="soal-4" align="justify">
                                                    5. Apabila anda pernah/sedang di proses di Kalbe Group, silahkan
                                                    sebutkan company-nya.
                                                </Typography>
                                                <Typography sx={{ fontWeight: "500" }}>
                                                    Answer: <br />
                                                    {dataCandidateByID.PreAssessment?.answer5
                                                        ? dataCandidateByID.PreAssessment?.answer5
                                                        : "Tidak ada"}
                                                </Typography>
                                            </div>
                                        ) : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button variant='contained' color='error' onClick={handleModalClose}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}

export default ModalPdfPreassesment